import React from 'react';
import { RetailerSource } from '../lib/supabase';
import { getRetailerUrl } from '../lib/useRetailers';

interface RetailerLinksProps {
  retailers: RetailerSource[];
  brand: string;
  blendName: string;
}

export default function RetailerLinks({ retailers, brand, blendName }: RetailerLinksProps) {
  if (!retailers || retailers.length === 0) {
    return null;
  }

  return (
    <div style={{
      paddingTop: '0.75rem',
      borderTop: '1px solid var(--color-border)'
    }}>
      <p style={{ 
        fontSize: '0.75rem', 
        color: '#cccccc',
        marginBottom: '0.5rem',
        fontWeight: 500
      }}>
        🔍 Quick Search:
      </p>
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap',
        gap: '0.5rem' 
      }}>
        {retailers.map(retailer => (
          <a
            key={retailer.id}
            href={getRetailerUrl(retailer.search_template, brand, blendName)}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '0.4rem 0.75rem',
              fontSize: '0.75rem',
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-accent)',
              color: 'var(--color-accent)',
              borderRadius: '6px',
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.25rem',
              transition: 'all 0.2s ease',
              fontWeight: 500
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-accent)';
              e.currentTarget.style.color = 'var(--color-background)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--color-card)';
              e.currentTarget.style.color = 'var(--color-accent)';
            }}
          >
            🔍 {retailer.name}
          </a>
        ))}
      </div>
    </div>
  );
}
